/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 4278423f2d4b49c995f02b72f6b991c75ab885901c6cf092c0e0723e792fc445
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './ButtonGroup.style'

export const ButtonGroupCompositionDependencies = ['Button'] as const

type ButtonGroupOwnProps = {
  className?: string
  layout?: 'default' | 'compact'
}

export type ButtonGroupProps = ButtonGroupOwnProps & Omit<ComponentProps<'div'>, keyof ButtonGroupOwnProps>

function ButtonGroup(props: ButtonGroupProps): ReactElement {
  const {
    children,
    className = '',
    layout = 'default',
    ...rest
  } = props

  return (
    <div
      className={cn('ButtonGroup', className, layout)}
      css={style}
      {...rest}
      role={rest.role ?? 'group'}
    >
      {children}
    </div>
  )
}

export default ButtonGroup
